import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
    constructor(type) {
        super()
        if (type === 'form') {
            // this.XDSJ = ''
            // this.KHSJH = ''
            // this.ZT = ''
            // this.DDZT = ''
            this.finalVenueId = ''
            this.orderStTime = ''
            this.orderEndTime = ''
            this.orderStatus = ''
            this.searchStatusType = '2'
            this.orderStatusText = '已支付'
            this.orderType = '0'
            this.searchCon = ''
            this.sportsProjectCode = ''
            this.payType = '1'
            this.orderFrom = '1'
        }
    }
}
export default searchFrom
